import React, { useCallback } from 'react';
import VisibilityOffIcon from '@mui/icons-material//VisibilityOff';
import VisibilityOutlinedIcon from '@mui/icons-material//VisibilityOutlined';
import { Box, FormControlLabel, IconButton, Switch, Tooltip } from '@mui/material';
import { VisibilityToggleProps, VisibilityToggleType } from './VisibilityToggle.props';

const VisibilityToggle = ({
  visible,
  onChange,
  tooltipTitle,
  type = VisibilityToggleType.BAR,
}: VisibilityToggleProps) => {
  const handleToggleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement> | null) => {
      event?.stopPropagation?.();
      event?.preventDefault?.();
      onChange(!visible);
    },
    [onChange, visible]
  );

  return (
    <Tooltip title={tooltipTitle} arrow>
      {type === VisibilityToggleType.ICON ? (
        <IconButton onClick={() => handleToggleChange(null)} type="button" color="primary" size="small">
          {visible ? <VisibilityOutlinedIcon color="primary" /> : <VisibilityOffIcon style={{ color: 'grey' }} />}
        </IconButton>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          bgcolor="var(--warning-100)"
          p={1}
          borderRadius={4}
          mt={5}>
          {visible ? <VisibilityOutlinedIcon color="primary" /> : <VisibilityOffIcon style={{ color: 'grey' }} />}
          <Box>
            <FormControlLabel
              control={
                <Switch
                  checked={visible}
                  onChange={event => handleToggleChange(event)}
                  color="primary"
                  size="small"
                  title="Show this Section"
                />
              }
              label="Show this Section"
              labelPlacement="start"
            />
          </Box>
        </Box>
      )}
    </Tooltip>
  );
};

export default VisibilityToggle;
